import {
  FormValues,
  Step,
  WizardStepChangeEventHandler } from 'components/types'
import { Location } from 'newTypes/location'
import { ChangeEvent } from 'react'

import FieldRender from './WizardFieldRender'

interface MultiStepProps {
  name: string
  label: string
  subSteps?: Step[]
  formValues: FormValues
  updateFormValue: (value: Location | WizardStepChangeEventHandler | ChangeEvent<HTMLInputElement> | any) => void
  setIsStepValid: (isValid: boolean) => void
}
const MultiStep = ({
  name,
  label,
  subSteps,
  formValues,
  updateFormValue,
  setIsStepValid,
}: MultiStepProps) => {
  if (!subSteps) return null

  return (
    <div>
      <label
        htmlFor={name}
        className="block text-imovSecondaryDark font-bold mb-2 p-2 pl-0 text-2xl sm:text-lg"
      >
        {label}
      </label>
      {subSteps.map((subStep: Step, index: number) => (
        <div key={`${name}-${index}`}>
          <FieldRender
            field={subStep}
            isFirstInput={false}
            parentStep={name}
            formValues={formValues}
            updateFormValue={updateFormValue}
            setIsStepValid={setIsStepValid}
          />
        </div>
      ))}
    </div>
  )
}

export default MultiStep
